import { useQuery } from '@tanstack/react-query';

import { listRevenueLeaks } from './revenue-api';

export const revenueKeys = {
  all: ['revenue'] as const,
  leaks: (branchId: string) => [...revenueKeys.all, 'leaks', branchId] as const,
};

export function useRevenueLeaks(branchId: string | undefined) {
  return useQuery({
    queryKey: branchId ? revenueKeys.leaks(branchId) : [...revenueKeys.all, 'leaks', '__pending__'],
    queryFn: () => listRevenueLeaks(branchId!),
    enabled: Boolean(branchId),
    staleTime: 30_000,
  });
}
